(function () {
  if (window.__invCollectionInHomeVideo) return;
  window.__invCollectionInHomeVideo = true;

  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function slotIsActive(slot) {
    if (slot === 'desktop') return isDesktop();
    if (slot === 'mobile') return !isDesktop();
    return false;
  }

  function getSlot(video) {
    var thumb = video.closest('[data-card-in-home-video]');
    return thumb ? thumb.getAttribute('data-in-home-slot') : null;
  }

  function isVideoVisible(video) {
    var thumb = video.closest('[data-card-in-home-video]');
    if (!thumb || thumb.offsetParent === null) return false;
    return slotIsActive(getSlot(video));
  }

  function playVideo(video) {
    if (!video || !isVideoVisible(video)) return;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!video || video.paused) return;
    video.pause();
  }

  function syncVideos(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-card-in-home-video] .th-video').forEach(function (video) {
      if (isVideoVisible(video)) {
        playVideo(video);
      } else {
        pauseVideo(video);
        video.currentTime = 0;
      }
    });
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      { threshold: 0.35 }
    );
  }

  function observeVideos(root) {
    if (!observer) return;
    var scope = root || document;
    scope.querySelectorAll('[data-card-in-home-video] .th-video').forEach(function (video) {
      if (video.dataset.inHomeObserved) return;
      video.dataset.inHomeObserved = '1';
      observer.observe(video);
    });
  }

  function boot(root) {
    observeVideos(root);
    syncVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', function () {
      syncVideos();
    });
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(function () {
      syncVideos();
    });
  }
})();
